import React from 'react'
import { Container, Row, Col, Card, ListGroup, } from "react-bootstrap";
import analyticsImg from './../../Images/da.jpg'; // <-- replace with your actual image
import Footer from '../Footer';
import Enquiry from '../enquiry';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet';

const DataAnalytics = () => {

    return (
        <>
            <Helmet>
                <title>Data Analytics Course in Coimbatore | GT SOFTWARE ACADEMY</title>
                <meta
                    name="description"
                    content="GT SOFTWARE ACADEMY in Coimbatore offers top Data Analytics and Data Science training programs with Python, SQL, Excel, Tableau, Power BI, and real-time projects. Job-ready courses with placement support for students and professionals."
                />
                <meta
                    name="keywords"
                    content="
    Data Analytics, Data Science, Data, Analysis, Analytics, Data Analyst, Python, R, SQL, Excel, Tableau, Power BI, Machine Learning, Artificial Intelligence, AI, Statistics, Bigdata, Modeling, Predictive, Algorithms, Visualization, Insights, Business Intelligence, Computer Science, Programming, Coding, Software, Technology, Tools, Skills, Training, Course, Certification, Career, Placement, Internship, Project, Portfolio, Resume, Companies, Recruiters, Corporate, Industry, Experts, Professionals, Students, Beginners, Advanced, Engineers, Developers, Scientists, Analysts, BTech, BSc, BCA, BCom, MCA, Engineering, Mathematics, Quantitative, Research, IT, Systems, Education, Graduate, Postgraduate, Workshop, Seminar, Coimbatore, Tamilnadu, India, GT SOFTWARE ACADEMY, GTSoftware, GTCollege, Institute, TrainingCenter, Online, Offline, Classroom
    "
                />
                <meta
                    property="og:title"
                    content="Data Analytics Course in Coimbatore | GT SOFTWARE ACADEMY"
                />
                <meta
                    property="og:description"
                    content="Master Data Analytics and Data Science with GT SOFTWARE ACADEMY, Coimbatore. Learn Python, SQL, Excel, Tableau, and visualization through real-world projects, case studies, and job-oriented training with placement support."
                />
                <meta
                    property="og:image"
                    content="https://gtcollege.in/path-to-image/cour2.PNG"
                />
                <meta property="og:type" content="website" />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://www.gtcollege.in/info-data-analytics" />

            </Helmet>

            <Container className="py-5">

                {/* Intro */}
                <Row className="mb-5 justify-content-center text-center">
                    <Col md={12} lg={12}>
                        <h2 className="fw-bold mb-3">
                            Welcome to <strong>GT SOFTWARE ACADEMY</strong> – Best <strong>Data Analytics Training in Coimbatore</strong>
                        </h2>
                        <p className="text-muted">
                            At <strong>GT SOFTWARE ACADEMY</strong>, we offer a cutting-edge <strong>Data Analytics</strong> and
                            <strong> Data Science</strong> program designed to equip learners with the essential <strong> skills  </strong>
                            to transform raw <strong>data</strong> into actionable <strong>insights</strong>.
                            Our comprehensive <strong>course</strong> covers everything from <strong>data collection</strong> and
                            <strong> data analysis</strong> to <strong>SQL</strong>, <strong>Python programming</strong>,
                            <strong>Excel</strong>, <strong>machine learning</strong>, and <strong>data visualization</strong>.
                            This job-ready training helps you gain <strong>business intelligence</strong> and
                            <strong> decision-making</strong> expertise, making you a skilled <strong> data analyst </strong>
                            and preparing you for high-demand <strong>career</strong> opportunities in Coimbatore and beyond.
                        </p>
                    </Col>
                </Row>

                {/* Why Data Analytics */}
                {/* <Row className="mb-5 lg e1" style={{ padding: "10px", opacity: "0.9", backgroundColor: "black" }}>
                    <Col md={6} style={{ padding: "15px" }}>
                        <img src={analyticsImg} style={{ height: "200px" }} className="a33" alt="Data Analytics" />
                    </Col>
                    <Col md={6} className="d-flex align-items-center">
                        <div>
                            <h3 className="fw-bold mb-3" style={{ color: "#7FB300" }}>Why Data Analytics?</h3>
                            <p style={{ color: "white" }}>
                                In today’s data-driven world, organizations across industries rely on data analytics to make informed
                                decisions and gain a competitive edge. Data analysts play a crucial role in interpreting complex data
                                sets, identifying trends, and delivering insights that drive strategy. Whether it’s in business, healthcare,
                                marketing, or finance, skilled data analysts are in high demand.
                            </p>
                        </div>
                    </Col>
                </Row> */}
                <Row className="mb-5 lg e1" style={{ padding: "10px", opacity: "0.9", backgroundColor: "black" }}>
                    <Col md={6} style={{ padding: "15px" }}>
                        <img
                            src={analyticsImg}
                            style={{ height: "200px" }}
                            className="a33"
                            alt="Data Analytics Training in Coimbatore | GT SOFTWARE ACADEMY"
                        />
                    </Col>
                    <Col md={6} className="d-flex align-items-center">
                        <div>
                            <h3 className="fw-bold mb-3" style={{ color: "#7FB300" }}>
                                Why <strong>Data Analytics</strong>?
                            </h3>
                            <p style={{ color: "white" }}>
                                In today’s <strong>data-driven world</strong>, organizations across industries rely on
                                <strong> Data Analytics</strong> and <strong>Data Science</strong> to make informed decisions
                                and gain a competitive edge. <strong>Data analysts</strong> play a crucial role in interpreting
                                complex <strong>data sets</strong>, identifying <strong>trends</strong>, and delivering
                                <strong> insights</strong> that drive <strong>business strategy</strong>.
                                Whether it’s in <strong>business</strong>, <strong>healthcare</strong>, <strong>marketing</strong>,
                                or <strong>finance</strong>, skilled <strong> data analysts</strong> are in high demand, making
                                <strong> Data Analytics training in Coimbatore</strong> with <strong> GT SOFTWARE ACADEMY </strong>
                                the best choice for a future-ready <strong>career</strong>.
                            </p>
                        </div>
                    </Col>
                </Row>


                {/* What You'll Learn */}
                <Row className="mb-5">
                    <Col>
                        <h3 className="fw-bold text-center mb-4">
                            What You'll Learn in <strong>Data Analytics Training at GT SOFTWARE ACADEMY Coimbatore</strong>
                        </h3>
                    </Col>
                </Row>

                <Row>
                    {/* 1 */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">
                                    1. Introduction to <strong>Data Analytics</strong>
                                </Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">
                                        📊 Overview of <strong>Data Analytics</strong> and its importance across industries
                                    </ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">
                                        🔄 Understanding the <strong>Data Analytics lifecycle</strong>
                                    </ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">
                                        🛠️ <strong>Tools and technologies</strong> used in <strong>Data Science</strong> & <strong>Analytics</strong>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* 2 */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">
                                    2. <strong>Data Collection</strong> and <strong>Cleaning</strong>
                                </Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">
                                        🌐 Techniques for collecting <strong>data</strong> from multiple sources
                                    </ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">
                                        🧹 <strong>Data wrangling</strong> & <strong>cleaning</strong>: removing inconsistencies, missing data & outliers
                                    </ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">
                                        💾 Introduction to <strong>databases</strong> and querying with <strong>SQL</strong>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* 3 */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">
                                    3. <strong>Data Analysis</strong> and <strong>Statistics</strong>
                                </Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">
                                        📈 <strong>Exploratory Data Analysis (EDA)</strong> techniques for identifying trends & patterns
                                    </ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">
                                        📊 Applying <strong>statistical methods</strong> to analyze <strong>data sets</strong>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* 4 */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">
                                    4. <strong>Data Visualization</strong>
                                </Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">
                                        🎨 Mastering <strong>Data Visualization tools</strong>
                                    </ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">
                                        📊 Designing effective <strong>charts, graphs, dashboards</strong> to present insights
                                    </ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">
                                        ✔️ Best practices for creating <strong>visualizations</strong> that communicate insights clearly
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* 5 */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">
                                    5. Real-World <strong>Projects</strong> & <strong>Case Studies</strong>
                                </Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">
                                        📂 Work on real-world <strong>data sets</strong> to apply your learning
                                    </ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">
                                        💡 Build <strong>data-driven solutions</strong> for <strong>business problems</strong>
                                    </ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">
                                        🤝 Collaborate with mentors & peers to refine <strong>analysis</strong> and
                                        <strong> visualization skills</strong>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Enquiry />
                </Row>


                {/* Why Choose Us */}
                {/* <Row className="mt-5">
                    <Col>
                        <h3 className="fw-bold text-center mb-4">Why Choose GT SOFTWARE ACADEMY?</h3>
                    </Col>
                </Row>
                <Row className="mt-5 text-center">
                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>👨‍🏫</h2>
                                <h5 className="fw-bold mt-2">Expert-Led Instruction</h5>
                                <p className="text-muted">
                                    Learn from experienced data analysts who have years of experience in the data analytics field.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>🖥️</h2>
                                <h5 className="fw-bold mt-2">Hands-On Learning</h5>
                                <p className="text-muted">
                                    Our projects, case studies, and practical assignments ensure that you gain experience that can be directly applied in the workforce.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>⚙️</h2>
                                <h5 className="fw-bold mt-2">Industry-Relevant Tools</h5>
                                <p className="text-muted">
                                    Get familiar with the latest tools and technologies used by data professionals.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>🚀</h2>
                                <h5 className="fw-bold mt-2">Job-Ready Skills</h5>
                                <p className="text-muted">
                                    By the end of the program, you'll have the skills needed to analyze data, visualize findings,
                                    and deliver actionable insights, making you a valuable asset to any organization.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row> */}
                <Row className="mt-5">
                    <Col>
                        <h3 className="fw-bold text-center mb-4">
                            Why Choose <strong>GT SOFTWARE ACADEMY Coimbatore</strong>?
                        </h3>
                    </Col>
                </Row>

                <Row className="mt-5 text-center">
                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>👨‍🏫</h2>
                                <h5 className="fw-bold mt-2">Expert-Led Instruction</h5>
                                <p className="text-muted">
                                    Learn from <strong>experienced Data Analysts</strong> and <strong>Data Science trainers</strong>
                                    with years of real-world expertise in the <strong>data analytics field</strong>.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>🖥️</h2>
                                <h5 className="fw-bold mt-2">Hands-On Learning</h5>
                                <p className="text-muted">
                                    Gain practical knowledge with <strong>projects</strong>, <strong>case studies</strong>,
                                    and <strong>real-world assignments</strong> that prepare you for a successful career in
                                    <strong>Data Analytics</strong>.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>⚙️</h2>
                                <h5 className="fw-bold mt-2">Industry-Relevant Tools</h5>
                                <p className="text-muted">
                                    Get hands-on experience with <strong>SQL</strong>, <strong>Python</strong>, <strong>Excel</strong>,
                                    and <strong>Data Visualization tools</strong> used by top <strong>Data Analytics professionals</strong>.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>🚀</h2>
                                <h5 className="fw-bold mt-2">Job-Ready Skills</h5>
                                <p className="text-muted">
                                    By the end of the program, you’ll master <strong>data analysis</strong>, <strong>visualization</strong>,
                                    and <strong>business intelligence</strong>, making you a valuable hire for companies in Coimbatore and beyond.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>

            <Footer />
        </>
    )
}

export default DataAnalytics;
// import React from 'react'
// import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
// import analyticsImg from './../../Images/cour2.PNG'; // <-- replace with your actual image
// import { Helmet } from 'react-helmet'
// const DataAnalytics = () => {
//     return (
//         <>
//            <Helmet>
//   <title>Data Analytics Course in Coimbatore | GT SOFTWARE ACADEMY</title>
//   <meta
//     name="description"
//     content="GT SOFTWARE ACADEMY offers Data Analytics courses in Coimbatore covering data analysis, Python, SQL, Excel, visualization, business intelligence, and placements for students and professionals."
//   />
//   <meta
//     name="keywords"
//     content="Data Analytics,Data, Data Analysis, Data Analytics Course in Coimbatore, Python,Tools, SQL, Excel, Data Visualization, Business Intelligence, Computer Science, Data Science, BTech, BCA, BCom, BSc, Data Analyst Training, Software, Programming, Career, Placement,Technologies, GT SOFTWARE ACADEMY"
//   />
//   <meta property="og:title" content="Data Analytics Course in Coimbatore | GT SOFTWARE ACADEMY" />
//   <meta
//     property="og:description"
//     content="Master Data Analytics with GT SOFTWARE ACADEMY in Coimbatore. Learn Python, SQL, Excel, and visualization with real projects and job-oriented training."
//   />
//   <meta property="og:image" content="https://gtcollege.in/path-to-image/cour2.PNG" />
//   <meta property="og:type" content="website" />
//   <meta name="robots" content="index, follow" />
// </Helmet>
//             <Container className="py-5">
//             {/* Intro */}
//             <Row className="mb-5 justify-content-center text-center">
//                 <Col md={12} lg={12}>
//                     <h1 className="fw-bold mb-3">Welcome to GT SOFTWARE ACADEMY</h1>
//                      <p className="text-muted">
//                         GT SOFTWARE ACADEMY offers the best <strong>Data Analytics training in Coimbatore</strong>, designed to help students and professionals
//                         master tools like <strong>Python, SQL, Excel</strong>, and <strong>Data Visualization</strong>. This comprehensive
//                         course transforms beginners into job-ready <strong>Data Analysts</strong>, skilled in turning raw data into
//                         meaningful <strong>business insights</strong> for industries like IT, finance, healthcare, and marketing.
//                     </p>
//                 </Col>
//             </Row>
//             {/* Why Data Analytics */}
//             <Row className="mb-5 lg" style={{ padding: "10px", opacity: "0.9", backgroundColor: "black" }}>
//                 <Col md={6} style={{ padding: "15px" }}>
//                     <img src={analyticsImg} style={{ height: "200px" }} className="a33" alt="Data Analytics" />
//                 </Col>
//                 <Col md={6} className="d-flex align-items-center">
//                     <div>
//                         <h3 className="fw-bold mb-3" style={{ color: "#7FB300" }}>Why Data Analytics?</h3>
//                         <p style={{ color: "white" }}>
//                             In today’s data-driven world, organizations across industries rely on data analytics to make informed
//                             decisions and gain a competitive edge. Data analysts play a crucial role in interpreting complex data
//                             sets, identifying trends, and delivering insights that drive strategy. Whether it’s in business, healthcare,
//                             marketing, or finance, skilled data analysts are in high demand.
//                         </p>
//                     </div>
//                 </Col>
//             </Row>
//             {/* What You'll Learn */}
//             <Row className="mb-5">
//                 <Col>
//                     <h3 className="fw-bold text-center mb-4">What You’ll Learn in Our Data Analytics Training (Python, SQL, Excel)</h3>
//                 </Col>
//             </Row>
//             <Row>
//                 {/* 1 */}
//                 <Col md={6} className="mb-4">
//                     <Card className="rounded-2 h-100">
//                         <Card.Body>
//                             <Card.Title className="fw-bold">1. Introduction to Data Analytics</Card.Title>
//                             <ListGroup variant="flush">
//                                 <ListGroup.Item className="border-0 ps-0">:bar_chart: Overview of data analytics and its importance in various industries</ListGroup.Item>
//                                 <ListGroup.Item className="border-0 ps-0">:arrows_counterclockwise: Understanding the data analytics lifecycle</ListGroup.Item>
//                                 <ListGroup.Item className="border-0 ps-0">:hammer_and_wrench: Tools and technologies used in data analytics</ListGroup.Item>
//                             </ListGroup>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//                 {/* 2 */}
//                 <Col md={6} className="mb-4">
//                     <Card className="rounded-2 h-100">
//                         <Card.Body>
//                             <Card.Title className="fw-bold">2. Data Collection and Cleaning</Card.Title>
//                             <ListGroup variant="flush">
//                                 <ListGroup.Item className="border-0 ps-0">:globe_with_meridians: Techniques for collecting data from multiple sources</ListGroup.Item>
//                                 <ListGroup.Item className="border-0 ps-0">:broom: Data wrangling and cleaning: Removing inconsistencies, missing data, and outliers</ListGroup.Item>
//                                 <ListGroup.Item className="border-0 ps-0">:floppy_disk: Introduction to databases and querying using SQL</ListGroup.Item>
//                             </ListGroup>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//                 {/* 3 */}
//                 <Col md={6} className="mb-4">
//                     <Card className="rounded-2 h-100">
//                         <Card.Body>
//                             <Card.Title className="fw-bold">3. Data Analysis and Statistics</Card.Title>
//                             <ListGroup variant="flush">
//                                 <ListGroup.Item className="border-0 ps-0">:chart_with_upwards_trend: Exploratory Data Analysis (EDA) techniques for identifying trends and patterns</ListGroup.Item>
//                                 <ListGroup.Item className="border-0 ps-0">:bar_chart: Applying statistical methods to analyze data sets</ListGroup.Item>
//                             </ListGroup>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//                 {/* 4 */}
//                 <Col md={6} className="mb-4">
//                     <Card className="rounded-2 h-100">
//                         <Card.Body>
//                             <Card.Title className="fw-bold">4. Data Visualization</Card.Title>
//                             <ListGroup variant="flush">
//                                 <ListGroup.Item className="border-0 ps-0">:art: Mastering data visualization tools</ListGroup.Item>
//                                 <ListGroup.Item className="border-0 ps-0">:bar_chart: Designing effective charts, graphs, and dashboards to present findings</ListGroup.Item>
//                                 <ListGroup.Item className="border-0 ps-0">:heavy_check_mark: Best practices for creating visualizations that communicate complex insights clearly</ListGroup.Item>
//                             </ListGroup>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//                 {/* 5 */}
//                 <Col md={6} className="mb-4">
//                     <Card className="rounded-2 h-100">
//                         <Card.Body>
//                             <Card.Title className="fw-bold">5. Real World Projects and Case Studies</Card.Title>
//                             <ListGroup variant="flush">
//                                 <ListGroup.Item className="border-0 ps-0">:open_file_folder: Work on real-world data sets to apply your learning in practical scenarios</ListGroup.Item>
//                                 <ListGroup.Item className="border-0 ps-0">:bulb: Build data-driven solutions for business problems</ListGroup.Item>
//                                 <ListGroup.Item className="border-0 ps-0">:handshake: Collaborate with mentors and peers to refine your analysis and visualization skills</ListGroup.Item>
//                             </ListGroup>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//             </Row>
//             {/* Why Choose Us */}
//             <Row className="mt-5">
//                 <Col>
//                     <h3 className="fw-bold text-center mb-4">Why Choose GT SOFTWARE ACADEMY for Data Analytics?</h3>
//                 </Col>
//             </Row>
//             <Row className="mt-5 text-center">
//                 <Col md={3} className="mb-4">
//                     <Card className="h-100 shadow-sm border-0.5 rounded-3">
//                         <Card.Body>
//                             <h2>:male-teacher:</h2>
//                             <h5 className="fw-bold mt-2">Expert-Led Instruction</h5>
//                             <p className="text-muted">
//                                 Learn from certified trainers with expertise in <strong>Data Analytics, Python, SQL, and Excel</strong>.
//                             </p>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//                 <Col md={3} className="mb-4">
//                     <Card className="h-100 shadow-sm border-0.5 rounded-3">
//                         <Card.Body>
//                             <h2>:desktop_computer:</h2>
//                             <h5 className="fw-bold mt-2">Hands-On Learning</h5>
//                             <p className="text-muted">
//                                 Our projects, case studies, and practical assignments ensure that you gain experience that can be directly applied in the workforce.
//                             </p>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//                 <Col md={3} className="mb-4">
//                     <Card className="h-100 shadow-sm border-0.5 rounded-3">
//                         <Card.Body>
//                             <h2>:gear:</h2>
//                             <h5 className="fw-bold mt-2">Industry-Relevant Tools</h5>
//                             <p className="text-muted">
//                                Work with modern <strong>Data Analytics and Visualization tools</strong> used by top companies.
//                             </p>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//                 <Col md={3} className="mb-4">
//                     <Card className="h-100 shadow-sm border-0.5 rounded-3">
//                         <Card.Body>
//                             <h2>:rocket:</h2>
//                             <h5 className="fw-bold mt-2">Job-Ready Skills</h5>
//                             <p className="text-muted">
//                                 By the end of the program, you'll have the skills needed to analyze data, visualize findings,
//                                 and deliver actionable insights, making you a valuable asset to any organization.
//                             </p>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//             </Row>
//         </Container>
//         </>
//     )
// }
// export default DataAnalytics;